module.exports = __webpack_public_path__ + "static/media/home.51d0d587.svg";